import { IFilterParams } from '@app/components/common/MainScreenWithFilterContainer/MainScreenWithFilterContainer';
import { TCsx } from '@emotion/react';
import { createColumnHelper } from '@tanstack/react-table';
import { IItemTableRow } from '@westondev/tableturn-core';
import { SetStateAction } from 'react';
import { WithTranslation } from 'react-i18next';
import { Dispatch } from 'redux';

export const columnHelper = createColumnHelper<IItemTableRow>();

export const ITEMS_TABLE_ID = 'main-screen-items-table';
export const ROW_ID_PREFIX = 'mainScreen-items-row-';

export type IMainScreenTable = WithTranslation & {
  filterParams: IFilterParams;
};

export type IItemsTable<> = IMainScreenTable & {
  isSelectionMode?: boolean;
  getFullValueOnRowSelectionChange?: boolean;
  setSelectedRows?: Dispatch<SetStateAction<any>>;
  selectedRows?: IItemTableRow[];
  runUnSelectAllRows?: boolean;
  stopUnSelectAllRows?: () => void;
  customItems?: IItemTableRow[];
  onNameClick?: (row: IItemTableRow) => void;
  replaceBreadCrumb?: boolean;
  csx?: TCsx;
  disableItemNameRef?: boolean;
};
